export default __webpack_public_path__ + "static/media/cu.8b800c64.svg";